<template>
    <div>
        <form @submit.prevent="form">
            <div class="card-body">
                <div class="row">
                    <div
                        class="col-md-12"
                        v-if="variantOptions === true"
                        style="text-align: center"
                    >
                        <div class="alert alert-danger">
                            <strong> {{ msjError }} </strong>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-row">
                            <div class="col-md-12">
                                <label for="city">{{ $t("lang.label_name") }}:</label>
                                <input
                                    type="text"
                                    v-model="name"
                                    class="form-control"
                                    required
                                    style="width: 100% !important"
                                />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-md-12">
                                <label for="description" style="margin-top: 10px">{{
                                    $t("lang.label_name_preview")
                                }}</label>
                                <input
                                    type="text"
                                    v-model="f.preview_name"
                                    class="form-control"
                                    required
                                    style="width: 100% !important"
                                />
                            </div>
                        </div>
                        <div class="form-row ex3">
                            <table class="table table-striped" style="margin-top: 10px">
                                <thead style="background-color: #cfd8dc">
                                    <tr>
                                        <th colspan="3">
                                            {{ $t("lang.label_option_name") }}
                                        </th>
                                    </tr>
                                </thead>
                                <draggable
                                    v-if="f.taks.length > 0"
                                    v-model="f.taks"
                                    tag="tbody"
                                    class="tbody"
                                    v-bind="dragOptions"
                                    @start="isDragging = true"
                                    @end="isDragging = false"
                                    handle=".handle"
                                >
                                    <tr v-for="(i, index) in f.taks" :key="index">
                                        <td style="cursor: pointer">
                                            <div class="handle">
                                                <i class="fas fa-align-justify"></i>
                                            </div>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="i.name"
                                                placeholder="Agregar Opciones"
                                                @change="addLine()"
                                                :ref="'taks' + index"
                                                :id="'taks' + index"
                                            />
                                        </td>
                                        <td class="text-center">
                                            <button
                                                type="button"
                                                class="btn btn-danger"
                                                :disabled="f.taks.length === 1"
                                                @click="delTaks(i.id, index)"
                                                style="
                                                    border-radius: 2px;
                                                    padding: 2px 4px;
                                                    font-size: 12px;
                                                "
                                            >
                                                <i class="fa fa-times"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </draggable>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <div class="text-center">
                    <button type="submit" class="btn btn-info" :disabled="btnSave">
                        <i class="fas fa-save"></i> {{ $t("lang.label_save") }}
                    </button>
                    <a
                        class="btn btn-success"
                        style="margin-left: 10px"
                        @click="hiddenCat()"
                        >{{ $t("lang.label_cancel") }}</a
                    >
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import draggable from "vuedraggable";
export default {
    name: "variantFormA",
    components: {
        draggable,
    },
    props: {
        variantFormA: { type: Object, required: true },
    },
    data () {
        return {
            m: {
                show: false,
                component: "",
                data: {},
            },
            isDragging: false,
            datacat: [],
            name: "",
            f: {
                id: 0,
                name: "",
                preview_name: "",
                taks: [],
                org_id: window.localuserdata,
                user_id: window.master_client,
                agruparOpt: [],
                category_id: 0,
                idPrices: 0,
                price: "0.10",
                actionForm: "create",
            },
            btnSave: false,
            change: false,
            agruparOpt: [],
            variantOptions: false,
            msjError: "",
            validado: [],
            validar: [],
        }
    },
    created () {
        this.init();
    },
    methods: {
        hiddenCat() {
            let data = {
                function: "cancelarAside",
                actions: "variant",
            };
            this.$store.commit("setvariantData", data);
        },
        init() {
            let g = this.$store.getters["getOpenModal"];
            this.change = true;
            let lineNew = {
                id: 0,
                name: null,
                id_variant_cat: 0,
                price: "0.10"
            };
            this.f.taks.push(lineNew);
            this.f.category_id = this.variantFormA.category_id;
            this.f.idPrices = this.variantFormA.idPrices;
            this.f.price = this.variantFormA.price;
            this.agruparOpt = this.variantFormA.agruparOpt;
            this.getDat();
        },
        getDat() {
            let url = "/menu/variantcat";
            window.master
                .post(url, this.f)
                .then((response) => {
                    this.validar = response.data.res;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        form() {
            // console.log(this.f);
            let e = this.validate(this.f);
            if (e.length === 1) {
                this.variantOptions = false;
                this.msjError = "";
                let taks = this.f.taks;
                let o = [];
                for (let i in taks) {
                    if (taks[i].name !== null) {
                        if (taks[i].name.length > 1) {
                            o.push(taks[i].name);
                        }
                    }
                }
                if (o.length > 0) {
                    this.variantOptions = false;
                    this.msjError = "";
                    let url = "/menu/variantform";
                    window.master
                        .post(url, this.f)
                        .then((response) => {
                            let assing = response.data.assing;
                            this.agruparOpt.push(assing);
                            this.$swal.fire({
                                type: "success",
                                title: "Save!",
                                text: "Save Successful",
                                showConfirmButton: false,
                                timer: 2000,
                            });
                            this.variantFormAReturn();
                        })
                        .catch((error) => console.log(error));
                } else {
                    this.variantOptions = true;
                    this.msjError = "No se ingresó el valor de la opción del artículo.";
                }
            } else {
                this.variantOptions = true;
                this.msjError = "Ya existe un conjunto de opciones con ese nombre.";
                if (this.id > 0) {
                    this.init();
                }
            }
        },
        validate(b) {
            let a = [];
            let name = b.name;
            let id = this.id;
            let r = this.validar;
            for (let i in r) {
                if (id !== r[i].id) {
                    if (name === r[i].name) {
                        a.push(true);
                    } else {
                        a.push(false);
                    }
                }
            }
            for (var i = a.length - 1; i >= 0; i--) {
                if (a.indexOf(a[i]) !== i) {
                    a.splice(i, 1);
                }
            }
            return a;
        },
        addLine() {
            let r = this.validateOptions();
            if (r === true) {
                this.variantOptions = true;
                this.btnSave = true;
                this.msjError = "Cada opción debe tener un nombre único.";
            } else {
                let res = this.f.taks.find((seach) => seach.name === null);
                if (res === undefined) {
                    this.variantOptions = false
                    // controlar la creacion de nuevas opciones
                    let lineNew = {
                        id: 0,
                        name: null,
                        id_variant_cat: 0,
                        price: "0.10"
                    };
                    this.f.taks.push(lineNew);
                    let idx = this.f.taks.length - 1;
                    setTimeout(function () {
                        let btnId = document.getElementById("taks" + idx);
                        if (btnId) {
                            btnId.focus();
                        }
                    }, 200);
                }
            }
        },
        delTaks(id, index) {
            this.f.taks.splice(index, 1);
            this.validado.splice(index, 1);
            let r = this.validateOptions();
            if (r === true) {
                this.variantOptions = true;
                this.btnSave = true;
                this.msjError = "Cada opción debe tener un nombre único.";
            } else {
                this.variantOptions = false;
                this.btnSave = false;
                this.msjError = "";
                this.addLine();
            }
        },
        validateOptions() {
            let b = this.validado;
            let r = new Set(b).size !== b.length;
            return r;
        },
        variantFormAReturn() {
            let t = this;
            let data = {
                function: "variantFormAsideReturn",
                agruparOpt: t.agruparOpt,
                actions: "variant",
            };
            this.$store.commit("setvariantData", data);
            this.rest();
        },
        rest() {
            this.f.taks = [];
            let lineNew = {
                id: 0,
                name: null,
                id_variant_cat: 0,
                price: "0.10"
            };
            this.f.taks.push(lineNew);
            this.f.preview_name = "";
            this.f.name = "";
            this.name = "";
        },
    },
    computed: {
        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost",
            };
        },
    },
    watch: {
        name: function (val) {
            if (this.change === true) {
                this.f.preview_name = val;
                this.f.name = val;
            }
        },
        f: {
            handler(val, oldVal) {
                let taks = val.taks;
                let o = [];
                for (let i in taks) {
                    if (taks[i].name !== null) {
                        if (taks[i].name.length > 1) {
                            o.push(taks[i].name);
                        }
                    }
                }
                if (o.length > 0) {
                    this.validado = o;
                }
            },
            deep: true,
        },
    },
}
</script>
<style lang="scss" scoped>
.card-footer {
    padding-top: 0 !important;
    padding-right: 1.25rem !important;
    padding-bottom: 1rem !important;
    padding-left: 1.25rem !important;
    background-color: inherit !important;
    border-top: 0px;
}
.moveCat {
    position: absolute;
    top: 0;
    left: -10px;
    width: 9px;
    height: 100%;
    background-color: #bfe8fb;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: move;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    cursor: pointer;
}
.table {
    width: 100% !important;
}
.card-header {
    padding-top: 0.3rem !important;
    padding-right: 1.25rem !important;
    padding-bottom: 0.3rem !important;
    padding-left: 1.25rem !important;
}
.card-body {
    padding-top: 5px !important;
    padding-right: 0px !important;
    padding-bottom: 0px !important;
    padding-left: 0px !important;
}
::-webkit-scrollbar {
    width: 6px;
}
::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 100px;
}
::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 100px;
}
::-webkit-scrollbar-thumb:hover {
    background: #555;
}
div.ex3 {
    width: 100%;
    height: 120px;
    overflow: auto;
}
</style>
